<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">
      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-left pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1" :disabled="false"
                  @click="getDataForTable()"
                  icon="refresh" tooltip="Ansicht aktualisieren" label="Aktualisieren"
                  :hide-label="true"></lx-btn>
          <lx-btn small classes="mr-1" :disabled="false"
                  @click="addTabToStore({routeName: 'CompanyNew', options: {icon: 'mdi-new-box', headline: 'Firma',label: {text: 'ungesichert'}}})"
                  icon="mdi-account-plus" tooltip="Neue Firma anlegen" label="Firma anlegen"
                  :hide-label="true"></lx-btn>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">
        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="CompaniesList"
              v-model="tableObj.selection"
              :items="companiesItems"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :tableOptions="tableObj.options"
              :hideContextFilter="true"
              @changeOptions="changeTableOptions"
              @rowClicked="openCompanyDetails"
              :no-data-text="$t('AG_GRID.NO_ROWS')"
              hide-default-footer
            >

              <template v-slot:cellrenderer="{ value }">
                <div v-if="value.f.renderer === 'checkbox'" style="height:35px;" class="layout-column layout-align-center-center">
                  <v-simple-checkbox :dark="compColor.isInDarkMode"
                                     :color="compColor.primeColor"
                                     :disabled="true"
                                     v-model="value.i.is_active"></v-simple-checkbox>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'CompaniesList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable"></lx-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LxPagination from "../../../components/lx_pagination/LxPagination"

export default {
  name: "CompaniesList",
  data () {
    return {
      companiesItems: [],
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      tableObj: {
        loading: false, // benutzt während des GetDatas um eine Ladeanimation einzublenden
        options: {
          sortBy: ['lastname'],
          sortDesc: [false],
        },
        selection: null,
        headers: [
          {
            text: this.$t('COMPONENT_ACCOUNT.LASTNAME'),
            value: 'lastname',
            sortable: true,
            width: '200px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.FIRSTNAME'),
            value: 'firstname',
            sortable: true,
            width: '200px'
          },
          {
            text: '_id',
            value: 'id',
            sortable: true,
            width: '200px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.EMAIL'),
            value: 'email',
            width: '250px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.IS_ACTIVE'),
            value: 'is_active',
            class: 'text-center',
            width: '40px',
            renderer: 'checkbox'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.LOGIN'),
            value: 'login_name'
          }
        ]
      }
    }
  },
  components: {
    LxPagination
  },
  created () {
    this.getDataForTable()
  },
  methods: {
    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * Methode wird vom Grid angesprungen wenn man doppelt auf eine Zeile klickt. Dann wird die Detailansicht geöffent.
     * Kann auch an einen Editbutton in einer Spalte gehangen werden aber Doppelklick ist komfortabler.
     * **/
    openCompanyDetails (params) {
      if (params && params.id) {
        this.addTabToStore({
          routeName: 'CompanyDetails',
          routeParams: { companyId: params.id },
          options: {
            headline: 'Firma ' + params.lastname + ', ' + params.firstname
          }
        })
      }
    },

    /**
     * Get all companies from db
     */
    getDataForTable (options) {
      if (this.tableObj.loading) return

      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      };

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = '{}'

      this.$http.get('/role/systemadmin?config={"opts":' + JSON.stringify(opts) + ', "query": ' + query + ', "count":true}')
        .then(res => {
          if (res.data) {
            this.companiesItems = res.data.result || []

            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'CompaniesList') {
        this.getDataForTable()
      }
    }
  }
}
</script>
